import Vue from 'vue';

Vue.filter('price', function (val, fix, isNull) {
  if (!val) return isNull ? '' : '0';
  fix = fix ? fix : 0;
  val = val.toFixed(fix).toString();
  return val.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
});